export { default } from './Verse';
